export const cyclePrice = (p, cycles, cycle) => Math.round(p.price * (cycles?.[cycle]?.factor || 1));

export const withService = (p, pct, service) => (service === "managed" && !p.features?.marketplace_only ? { ...p, price: Math.round(p.price * (1 + (Number(pct) || 0) / 100)) } : p);

export const ServiceToggle = ({ service, setService }) => (
  <div className="inline-flex flex-wrap items-center gap-1 p-1 mb-4 rounded-2xl sm:rounded-full bg-white border border-slate-200" data-testid="service-toggle">
    {[["self", "Self-served website builder"], ["managed", "Managed service website & builder"]].map(([k, l]) => (
      <button key={k} type="button" onClick={() => setService(k)} className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-colors ${service === k ? "bg-[#B8924A] text-white" : "text-slate-600 hover:text-[#0B3B2E]"}`} data-testid={`service-${k}`}>{l}</button>
    ))}
  </div>
);

export const CycleToggle = ({ cycle, setCycle, cycles }) => (
  <div className="inline-flex flex-wrap items-center gap-1 p-1 mb-8 rounded-2xl sm:rounded-full bg-white border border-slate-200" data-testid="billing-cycle-toggle">
    {Object.entries(cycles || {}).map(([k, v]) => (
      <button key={k} type="button" onClick={() => setCycle(k)} className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-colors ${cycle === k ? "bg-[#0B3B2E] text-white" : "text-slate-600 hover:text-[#0B3B2E]"}`} data-testid={`billing-cycle-${k}`}>
        {k[0].toUpperCase() + k.slice(1)}{v.save && <span className={`ml-1 font-normal ${cycle === k ? "text-[#E2C68F]" : "text-[#A9823F]"}`}>· {v.save}</span>}
      </button>
    ))}
  </div>
);
